import type { LucideIcon } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

import { Spinner } from './Spinner.js';
import styles from './ActionTile.module.css';

export function ActionTile({
    icon: Icon,
    label,
    hint,
    loading = false,
    disabled = false,
    onClick,
}: {
    icon: LucideIcon;
    label: string;
    hint?: ReactNode;
    loading?: boolean | undefined;
    disabled?: boolean | undefined;
    onClick: () => void;
}): ReactElement {
    return (
        <button
            type="button"
            className={styles.tile}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            onClick={onClick}
        >
            <span className={styles.icon} aria-hidden="true">
                {loading ? (
                    <Spinner size="sm" label="Working" />
                ) : (
                    <Icon size={22} strokeWidth={2} />
                )}
            </span>
            <span className={styles.copy}>
                <span className={styles.label}>{label}</span>
                {hint !== undefined && hint !== null && hint !== '' ? (
                    <span className={styles.hint}>{hint}</span>
                ) : null}
            </span>
        </button>
    );
}
